import { Component, OnInit, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { EventInfoComponent } from "../../../modals/event-info/event-info.component";
import { SelectionInfoComponent } from "../../../modals/selection-info/selection-info.component";
import { NextTenOddsComponent } from "../../../components/betting/next-ten/next-ten-odds/next-ten-odds.component";
import { StmgService } from "../../../services/state_Management/stmg.service";
import { BettingServiceService } from "../../../services/betting_service/betting-service.service";
import { meetingMeta_pObj,meetingMeta_greyHound_pObj } from "../../../services/payload/meetingMeta_pobj";
import { AlertComponent } from "../../../components/alert/alert.component";
import { AlertController } from "@ionic/angular";
import { eventSelectionMeta_pObj } from "../../../services/payload/eventSelectionMeta_pObj";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { Subscription } from 'rxjs';
import { CommonServiceService } from '../../../services/common_service/common-service.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-race-details",
  templateUrl: "./race-details.component.html",
  styleUrls: ["./race-details.component.scss"],
  providers: [NextTenOddsComponent],
})
export class RaceDetailsComponent implements OnInit {
  subscription: Subscription;
  disable_SP_subscription: Subscription;


  eventDataset: any = [];
  eventSelectionDataSet: any = [];
  selection: any = {
    eventSelections: []
  };

  selectionType: string = "";
  maxCount: boolean = false;


  selectionInfo_meta_Name: any;
  selectionInfo_metaNumber: number;
  selectionInfo_metajerseyIcon: any = "";
  selectionInfo_showJersey: any;
  // isjerseyIcon_appear : boolean;

  metaEventLable: any;
  metaEventName: any;
  metaEventLocalDate: any;
  metaeventTime: any;
  is_logged: boolean = false;
  is_AU : boolean = false;
  info_button_show: boolean = true;


  @Input() selectedMeeting: any;
  selectionOdds: any = [];

  @Input() betcatselection: any;

  currentSelectedBets: any = null;    // Block Games

  constructor(
    public modalController: ModalController,
    public comp_next10: NextTenOddsComponent,
    private stmgService: StmgService,
    private bettingService: BettingServiceService,
    public alertController: AlertController,
    private commonservice: CommonServiceService,
    public translate: TranslateService,
  ) {

    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commonservice.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
  }

  ngOnInit() {
    let el = document.getElementById('top');
    if(el){el.scrollIntoView();}
    
    this.getSelectionOdds(this.selectedMeeting.id);
    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if (selectedBets) {
        this.selection = selectedBets;
      }

    });

    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message

    );

    // Block Games
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });
    
  }
  

  viewEventDetails(data: any) {
    this.getMeetingMetaData(data);
  }



  async PopUpEventInfoModel(event,metaData) {

    const modal = await this.modalController.create({
      component: EventInfoComponent,
      componentProps: { 
        metaData:metaData,
        event:event
       },
      cssClass: 'customPopup'
    });
    return await modal.present();
  }


  selectionData;
  viewInfoDetails(oddData: any) {
    //console.log(oddData)
    this.bettingService.getSelectionMetaData(oddData.id).subscribe((data) => {
        this.selectionData=data;
        //console.log(this.selectionData);
        this.openSelectionPopup(oddData);
      },
      (error) => { }
    );
    
  }


  async openSelectionPopup(oddData) {
    const modal = await this.modalController.create({
      component: SelectionInfoComponent,
      cssClass: "customPopup",
      componentProps:{
        oddData:oddData,
        selectionData:this.selectionData
      },
    });
    return await modal.present();
  }



  getSelectedEvent_Info(selectedMetaID) {
    this.bettingService.getSelectionMetaData(selectedMetaID).subscribe(
      (data) => {
        this.validatePayload(data);
      },
      (error) => { }
    );
  }


    async PopUpviewInfoDetails(selectionInfo_meta_data) {
    const modal = await this.modalController.create({
      component: SelectionInfoComponent,
      cssClass: "customPopup",
      componentProps: { selectionInfo_meta_data },
    });
    return await modal.present();
  }

  backToMettingView() {
    this.stmgService.updateResultBackButton(false);

  }

  // Get meeting metaData
  getMeetingMetaData(eventData: any) {
    this.bettingService.getEventMetaData(eventData.id).subscribe(
      (data) => {
        this.PopUpEventInfoModel(eventData,data);
       
      },
      (error) => { }
    );
  }

  validatePayload(data: any) {
    this.eventSelectionDataSet = data;

    if (
      this.eventSelectionDataSet == undefined ||
      this.eventSelectionDataSet == null ||
      this.eventSelectionDataSet.length == 0
    ) {
      let alert = new AlertComponent(this.alertController);
      alert.launchAlert(
        "",
        "Selection Event Info",
        "No Selection Info for this event Selection"
      );
    } else {


      let selectionInfo_meta_data = new eventSelectionMeta_pObj();

      selectionInfo_meta_data.isjerseyIconShown = this.selectionInfo_showJersey;
      selectionInfo_meta_data.jerseyIcon = this.selectionInfo_metajerseyIcon;
      selectionInfo_meta_data.shirtNumber = this.selectionInfo_metaNumber;
      selectionInfo_meta_data.name = this.selectionInfo_meta_Name;
      selectionInfo_meta_data.age_years = this.eventSelectionDataSet.age_years;
      selectionInfo_meta_data.horse_form = this.eventSelectionDataSet.horse_form;
      selectionInfo_meta_data.horse_jockey_name = this.eventSelectionDataSet.horse_jockey_name;
      selectionInfo_meta_data.horse_status_places = this.eventSelectionDataSet.horse_status_places;
      selectionInfo_meta_data.horse_status_prizemoney = this.eventSelectionDataSet.horse_status_prizemoney;
      selectionInfo_meta_data.horse_status_runs = this.eventSelectionDataSet.horse_status_runs;
      selectionInfo_meta_data.horse_status_wins = this.eventSelectionDataSet.horse_status_wins;
      selectionInfo_meta_data.owner_name = this.eventSelectionDataSet.owner_name;
      selectionInfo_meta_data.runner_commments = this.eventSelectionDataSet.runner_commments;
      selectionInfo_meta_data.trainer_name = this.eventSelectionDataSet.trainer_name;
      selectionInfo_meta_data.weight_value = this.eventSelectionDataSet.weight_value;

      this.PopUpviewInfoDetails(selectionInfo_meta_data);
    }
  }

  updateMeetingDataSTMG(d: any) {
    this.stmgService.updateMeetingData(d);
  }

  getSelectionOdds(id: any) {

    this.bettingService.getEventSelections(id).subscribe(
      (data) => {

        this.selectionOdds = data;
        
      },
      (error) => { }
    );
  }

  //method for virtual fraction button example 11/2 button
  setPriceOdd(value: any) {
    this.selectionType = 'PO';
    value.fr_clicked = !value.fr_clicked;
    value.clicked = false;

    if (value.fr_clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.fr_clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }


  }

  //method for SP buttons
  setSPOdd(value: any) {
    this.selectionType = 'SP';
    value.clicked = !value.clicked;
    value.fr_clicked = false;

    if (value.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }

  }


  //method for type 'PD'
  setPriceDecimalOdd(value: any) {

    this.selectionType = 'PD';
    value.clicked = !value.clicked;

    if (value.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }

  }

  placeBetObj(d: any, t: string) {

     // Block Games Selections
    if (!this.selection) {
      this.selection = { eventSelections: [] };
    }
    if (!this.selection.eventSelections) {
      this.selection.eventSelections = [];
    }

    // **CHECK if game bets exist**
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      console.log('Races - Inside check, currentBets exists');
      
      const isKironGame = this.currentSelectedBets.payload && (this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions');
      console.log('Races - isKironGame:', isKironGame);
      
      if (isKironGame && this.currentSelectedBets.payload.eventSelections) {
        const hasGameBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        console.log('Races - hasGameBets:', hasGameBets);
        
        if (hasGameBets) {
          this.showBlockAlert();
          d.clicked = false;
          d.fr_clicked = false;
          return;
        }
      }
    }

    let oddD: any;
    let oddF: any;
    let win: number = 0;
    let place: number = 0;


    switch (t) {

      case 'SP':
        oddF = 'N';
        oddD = 0.0;
        break;

      case 'PO':
        oddF = d.priceOdds.priceFraction;
        oddD = 0.0;
        break;

      case 'PD':
        oddF = 'N';
        oddD = d.priceOdds.priceDecimal;
        break;

    }

    let tempObj = {
      id: d.id,
      oddD: oddD,
      oddF: oddF,
      win: win,
      place: place,
      sportType: d.id
    }

    if (t == "SP") {
      if (d.clicked == true) {
        this.maxCount = this.checkMaximuSelectionCount();
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {

          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            //remove old row
            this.selection.eventSelections.splice(index, 1);
            //add new row
            this.selection.eventSelections.push(tempObj);
            break;
          }

        }

        // add row
        if (index == -1) {
          this.selection.eventSelections.push(tempObj);
        }


      } else {
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {

          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            // remove row
            this.selection.eventSelections.splice(index, 1);
            break;
          }

        }
      }

    }



    if (t == "PO") {
      if (d.fr_clicked == true) {
        this.maxCount = this.checkMaximuSelectionCount();
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {
          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            //remove old row 
            this.selection.eventSelections.splice(index, 1);
            //add new row
            this.selection.eventSelections.push(tempObj);
            break;
          }

        }

        // add row
        if (index == -1) {
          this.selection.eventSelections.push(tempObj);
        }


      } else {
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {
          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            // remove row
            this.selection.eventSelections.splice(index, 1);
            break;
          }

        }
      }
    }

    this.stmgService.updateSelecteBets(this.selection);
  }

  checkMaximuSelectionCount(): boolean {

    if (!this.selection || !this.selection.eventSelections) {
      return false;
    }

    const selectionArray = this.selection.eventSelections.filter(m => !m?.isKR3);

    return selectionArray.length === 4;
  }

  // checkMaximuSelectionCount() {
  //   let val: boolean;
  //   let selectionArray=this.selection.eventSelections.filter(m=>!m.isKR3)
  //   if(selectionArray.length == 4){
  //     val = true;
  //   } else {
  //     val = false;
  //   }
  //   return val;
  // }

  showMaxCountAlert() {
    let alertTitle:string;
    let alertDesc:string;
    this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
      alertTitle=res;
    });
    this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
      alertDesc=res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("",alertTitle,alertDesc);
  }

  // Block Slecetion with Games
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

}
